import Cart from "../models/cart";
import Payment from "../models/payment";
import Summary from "../models/summary";

export const emptyCart: Cart = {
    memberId: 0,
    cartId: 0,
    status: 0,
    cartItems: [],
    isPaymentLink: false,
    discountPercentage:0,
    summary: {
        total: "0.00",
        subTotal: "0.00",
        tax: "0.00",
        taxPercentage: "0",
        discount: "0.00",
        discountPercentage: "0",
        currency: "",
        coupon: {},
        cartId: 0,
        detailsList : []
    },
    widgets: [],
}
export const emptyPayment: Payment = {
    id: '',
    source_transaction_id: '',
    payment_secret: '',
    available_methods: [],
    footer: []
}

export const summary:Summary = {
    total: "0.00",
    subTotal: "0.00",
    tax: "0.00",
    taxPercentage: "0",
    discount: "0.00",
    discountPercentage: "0",
    currency: "",
    coupon: {},
    cartId: 0,
    detailsList : []
}